import {useLayoutEffect, useState} from 'react'
import {useCookies} from 'react-cookie'
import {useAppSelector} from 'src/hooks'

type ScopeCookieEntry = {scope: string, cookie: string}

const COOKIE_OPTIONS = {maxAge: 86400, secure: true, path: '/'} as const

function decodeTokens(payload: string): ScopeCookieEntry[] {
  try {
    return JSON.parse(Buffer.from(payload, 'base64').toString())
  } catch {
    return []
  }
}

export function useBootstrapSession(): {sessionReady: boolean} {
  const [cookies, setCookies] = useCookies(['sid', 'tokens'])
  const pspScope = useAppSelector(state => state.pspConfigReducer.data.scope)
  const [sessionReady, setSessionReady] = useState(false)

  useLayoutEffect(() => {
    const url = new URL(window.location.href)
    const queryCookies = url.searchParams.get('cookies')
    const queryScope = url.searchParams.get('scope')
    const scope = pspScope !== '' ? pspScope : queryScope

    let tokensPayload: string | undefined
    if (queryCookies) {
      setCookies('tokens', queryCookies, COOKIE_OPTIONS)
      tokensPayload = queryCookies
    } else if (cookies.tokens) {
      tokensPayload = cookies.tokens
    }

    if (tokensPayload && scope) {
      const tokens = decodeTokens(tokensPayload)
      const scopeCookie = tokens.find(entry => entry.scope === scope)?.cookie
      if (scopeCookie) {
        setCookies('sid', scopeCookie, COOKIE_OPTIONS)
      }
    }

    setSessionReady(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {sessionReady}
}
